import type { MetersModule, SessionsMeters } from '@/types/organization'

export const METERS_MODULE_IDS = [
	'devices',
	'dashboards',
	'actions',
	'sessions',
	'dbc',
	'exporters',
	'streams',
	'users',
	'roles',
	'metadata',
	'apikeys',
] as const satisfies readonly MetersModule[]

export const METERS_MODULE_TABS: ReadonlyArray<{ key: MetersModule; name: string }> = [
	{ key: 'devices', name: 'Devices' },
	{ key: 'dashboards', name: 'Dashboards' },
	{ key: 'actions', name: 'Actions' },
	{ key: 'sessions', name: 'Sessions' },
	{ key: 'dbc', name: 'DBC' },
	{ key: 'exporters', name: 'Exporters' },
	{ key: 'streams', name: 'Streams' },
	{ key: 'users', name: 'Users' },
	{ key: 'roles', name: 'Roles' },
	{ key: 'metadata', name: 'Metadata' },
	{ key: 'apikeys', name: 'API Keys' },
]

/** Modules whose API payload is `{ consumed, allowed }` and share the same table/search shape. */
export const CONSUMED_ALLOWED_METER_MODULES: ReadonlySet<MetersModule> = new Set([
	'devices',
	'dashboards',
	'users',
	'roles',
	'metadata',
	'dbc',
	'exporters',
	'apikeys',
])

type SessionMetersKey = keyof SessionsMeters['meters']

export interface SessionMeterUsageField {
	id: string
	header: string
	consumedKey: SessionMetersKey
	allowedKey: SessionMetersKey
	consumedSearchLabel: string
	allowedSearchLabel: string
	tableSize?: number
}

export const SESSION_METER_USAGE_FIELDS: readonly SessionMeterUsageField[] = [
	{
		id: 'session_rules',
		header: 'Session Rules',
		consumedKey: 'session_rules_consumed',
		allowedKey: 'session_rules_allowed',
		consumedSearchLabel: 'Session Rules Consumed',
		allowedSearchLabel: 'Session Rules Allowed',
	},
	{
		id: 'subscriber_groups',
		header: 'Subscriber Groups',
		consumedKey: 'subscriber_groups_consumed',
		allowedKey: 'subscriber_groups_allowed',
		consumedSearchLabel: 'Subscriber Groups Consumed',
		allowedSearchLabel: 'Subscriber Groups Allowed',
	},
]
